export const pt = {
    consent: {
        titulo: "Consentimento de cookies",
        texto: "Utilizamos cookies para medir visitas e melhorar a comunicação do evento. A medição de marketing só é ativada com o teu consentimento.",
        aceitar: "Aceitar",
        rejeitar: "Só essenciais",
        saberMais: "Saber mais",
    },
    nav: {
        experiencia: "Experiência",
        noiteFados: "Noite de Fados",
        equipa: "Equipa",
        artistas: "Artistas",
        noticias: "Notícias",
        missao: "Missão",
        associacao: "A Associação",
        vantagens: "Vantagens de Sócio",
        contacto: "Contacto",
        reservar: "Reservar",
        local: "Como Chegar",
    },
    hero: {
        headlineTop: "UMA NOITE\nDEDICADA AO",
        headlineAdj: "PORTUGUÊS",
        headlineItalico: "Uma noite portuguesa.\nÀ mesa.\nAo vivo.",
        quando: "Quando",
        data: "14 de Novembro de 2026",
        hora: "a partir das 17h00",
        onde: "Onde",
        local: "Centro Papa Giovanni",
        morada: "Hübelistrasse 55, Emmenbrücke",
        comprar: "Comprar Bilhetes",
        urgencia: "Evento exclusivo · Lugares limitados",
        saibaMais: "Saiba Mais",
        countdown: {
            label: "Preço Early Bird termina em",
            dias: "dias",
            horas: "horas",
            min: "min",
            seg: "seg",
        },
    },
    pillars: [
        { id: "fado-ao-vivo", title: "Fado ao Vivo", text: "A emoção do Fado, património imaterial de Portugal." },
        { id: "gastronomia", title: "Gastronomia Portuguesa", text: "Sabores tradicionais num jantar preparado com excelência." },
        { id: "vinhos", title: "Vinhos Portugueses", text: "Seleção de vinhos das melhores regiões de Portugal." },
        { id: "cultura", title: "Cultura e Tradição", text: "Uma celebração da nossa identidade, história e hospitalidade." },
        { id: "ambiente", title: "Ambiente Exclusivo", text: "Um espaço íntimo para uma experiência inesquecível." },
    ],
    watermark: "Exemplo Visual",
    influencer: {
        label: "Influencer Oficial",
        nome: "Nelson Jackson",
        titulo: "A voz que leva o Fados à Mesa à comunidade",
        texto: "O Nelson Jackson é o influencer oficial do Fados à Mesa. Com a bandeira ao peito e a energia de sempre, vai acompanhar connosco a contagem decrescente para a noite de 14 de Novembro — bastidores, novidades e surpresas nas redes sociais.",
        legenda: "Mensagem do Nelson Jackson à comunidade portuguesa",
        play: "Ver o vídeo",
    },
    convidadoHonra: {
        label: "Convidado de Honra",
        confirmado: "Participação confirmada",
        bemVindo: "Seja bem-vindo, Excelência!",
        excelencia: "Sua Excelência",
        nome: "Dr. Gonçalo Motta",
        cargo: "Cônsul Geral de Portugal em Zurique",
        citacao: "A cultura aproxima-nos. Portugal vive em cada um de nós.",
        texto: "É com grande honra que recebemos Sua Excelência o Dr. Gonçalo Motta, Cônsul Geral de Portugal em Zurique, como nosso convidado de honra no Fados à Mesa. A presença da representação diplomática de Portugal é um reconhecimento do valor da cultura portuguesa e da importância de manter vivas as nossas tradições, unindo a comunidade em torno da música, da gastronomia e da nossa identidade.",
        sobreTitulo: "Sobre o Dr. Gonçalo Motta",
        sobre: "O Dr. Gonçalo Motta é o atual Cônsul Geral de Portugal em Zurique, em representação do Ministério dos Negócios Estrangeiros de Portugal. Com formação pela Universidade Lusíada de Lisboa e uma vasta experiência diplomática, dedica-se ao reforço das relações entre Portugal e a Suíça, ao apoio às comunidades portuguesas e à promoção da cultura e da imagem de Portugal no estrangeiro.",
        verCartaz: "Ver o cartaz oficial",
    },
    patrocinadores: {
        titulo: "PATROCINADORES OFICIAIS",
        maisA: "E mais",
        maisB: "Patrocinadores",
        agradecimentos: {
            famosa: "O nosso profundo agradecimento à Pastelaria Famosa, Patrocinadora Exclusiva, pela confiança e pela doçura com que abraça esta noite desde o primeiro dia.",
            srVinho: "Obrigado ao Sr. Vinho, restaurante típico que recebe os nossos sócios com 10% de desconto e um digestivo de oferta.",
            cr7Helder: "O nosso sincero agradecimento ao CR7 Helder, por acreditar no Fado e nos conduzir, com elegância, até esta noite.",
            saboresPortugal: "O nosso sincero agradecimento ao Sabores de Portugal, por trazer à mesa o melhor da nossa gastronomia e dar a esta noite um verdadeiro sabor a Portugal.",
            wildenMann: "Obrigado ao Hotel Wilden Mann, cinco séculos de hospitalidade luzernense ao lado do Fado.",
            barniPost: "Obrigado ao Barni-Post, por levar o Fado a todas as casas da Suíça Central.",
            superBock: "Obrigado ao Super Bock Group, por trazer à mesa o sabor mais português das cervejas.",
            clubPortugues: "Obrigado ao Club Português Luzern, casa da nossa comunidade há tantos anos.",
            casaBenfica: "Obrigado à Casa Benfica Zurique, pela paixão que une portugueses de norte a sul da Suíça.",
            immoHaus: "Obrigado à ImmoHaus Portugal, por ajudar tantas famílias a encontrar casa — e por nos abrir a sua.",
        },
    },
    artistas: { titulo: "OS NOSSOS ARTISTAS" },
    parceiros: { titulo: "PARCEIROS INSTITUCIONAIS" },
    localizacao: {
        saberMais: "Saber Mais",
        label: "Onde decorre o evento",
        titulo: "COMO CHEGAR",
        intro: "O evento realiza-se em Emmenbrücke, com acesso por transporte público, carro ou bicicleta. Abaixo, a informação prática de chegada.",
        moradaLabel: "Morada",
        moradaValor: "Centro Papa Giovanni, Hübelistrasse 55, 6020 Emmenbrücke, Suíça",
        gpsLabel: "Coordenadas GPS",
        gpsValor: "47.0706° N, 8.2849° E",
        acessosTitulo: "Acessos",
        transportesTitulo: "Transporte Público",
        transportes: "Estação Emmenbrücke Gersag a cerca de 10 minutos a pé (comboios regionais e autocarros 41, 42, 43 e 44). De Lucerna, linha VBL 2; no regresso, autocarro noturno N2.",
        carroTitulo: "Carro",
        carro: "A 5 minutos da autoestrada A2 (saída Emmen Nord).",
        bicicletaTitulo: "Bicicleta",
        bicicleta: "Estacionamento para bicicletas disponível no local.",
        estacionamentoTitulo: "Estacionamento Gratuito",
        estacionamento: "Estacionamento gratuito da Häger mesmo em frente — apenas os lugares sinalizados «Häger», sujeitos a disponibilidade. Mais parques nas imediações, gratuitos e pagos.",
        regrasTitulo: "Regras do Centro Papa Giovanni",
        regras: [
            "Proibida a entrada e permanência de animais de estimação.",
            "Proibido fumar em toda a área interior do edifício.",
        ],
    },
    cta: {
        comprar: "Comprar Bilhetes",
        urgencia: "Evento exclusivo · Lugares limitados",
        titulo: "RESERVE JÁ O SEU LUGAR.",
        subtitulo: "Uma noite. Uma mesa. Um Fado.",
    },
    culturaNoticias: {
        noticias: "ÚLTIMAS NOTÍCIAS",
        nota: "Notícias de exemplo — as novidades sobre o evento vão aparecendo aqui.",
        news: [
            { title: "Fados à Mesa lança a primeira edição em 14 novembro 2026", date: "15 MAI 2025" },
            { title: "Conheça os artistas que dão vida ao Fado em palco", date: "10 MAI 2025" },
            { title: "Sabores de Portugal: o jantar que celebra a nossa tradição", date: "05 MAI 2025" },
        ],
    },
    footer: {
        frase: "Uma noite Portuguesa, com toda a certeza.",
        copyright: "© 2026 Fados à Mesa – Todos os direitos reservados.",
        sede: "Associação Fados à Mesa · UID CHE-306.330.271 · Gerliswilstrasse 46, 6020 Emmenbrücke, Suíça",
        privacy: "Política de Privacidade",
        terms: "Termos e Condições",
        colunas: [
            {
                title: "Noite de Fados",
                links: [
                    { label: "Menu do Evento", to: "/experiencia?tab=menu" },
                    { label: "Cultura e Tradição", to: "/experiencia?tab=cultura" },
                    { label: "Gastronomia e Vinhos", to: "/experiencia?tab=gastro" },
                    { label: "Bar", to: "/experiencia?tab=bar" },
                    { label: "Equipa", to: "/equipa", ate1aEdicao: true },
                ],
            },
            {
                title: "Artistas",
                links: [
                    { label: "Artistas", to: "/#artistas" },
                    { label: "Notícias", to: "/noticias" },
                ],
            },
            {
                title: "A Associação",
                links: [
                    { label: "Missão", to: "/missao" },
                    { label: "Vantagens de Sócio", to: "/socios/vantagens" },
                    { label: "Tornar-se Sócio", to: "/associacao#adesao" },
                    { label: "Patrocinadores", to: "/patrocinadores" },
                ],
            },
            {
                title: "Bilhetes",
                links: [
                    { label: "Comprar Bilhetes", to: "/bilhetes" },
                    { label: "Confirmar Presença", to: "/confirmar" },
                ],
            },
            {
                title: "Contacto",
                links: [
                    { label: "Contactos", to: "/contacto" },
                    { label: "Como Chegar", to: "/local" },
                    { label: "Centro de Recursos", to: "/recursos" },
                ],
            },
        ],
    },
    subpage: { voltar: "Voltar" },
    audio: { tocar: "Tocar música", pausar: "Pausar música" },
    bc: {
        home: "Início",
        experiencia: "Experiência",
        equipa: "Equipa",
        artistas: "Artistas",
        noticias: "Notícias",
        missao: "Missão",
        contacto: "Contacto",
        local: "Localização",
        confirmar: "Confirmação",
        bilhetes: "Bilheteira",
        privacidade: "Política de Privacidade",
        termos: "Termos e Condições",
        recursos: "Centro de Recursos",
        patrocinadores: "Patrocinadores",
    },
    seo: {
        keywords: "Fado, Fados à Mesa, cultura portuguesa, gastronomia portuguesa, vinhos portugueses, evento português Suíça, Fado Lucerna, Emmenbrücke, jantar espetáculo, Ticket Corner",
        home: { title: "Fados à Mesa — Fado, Gastronomia e Vinhos na Suíça", desc: "Jantar-espetáculo com Fado ao vivo, gastronomia e vinhos portugueses. 14 de novembro de 2026, Centro Papa Giovanni, Emmenbrücke. Reserve o seu bilhete." },
        experiencia: { title: "A Experiência — Menu, Line-up e Etiqueta do Fado | Fados à Mesa", desc: "Conheça o menu oficial, o line-up da noite e a etiqueta do Fado: uma noite portuguesa servida à mesa, entre pratos tradicionais e momentos de Fado ao vivo." },
        equipa: { title: "A Nossa Equipa — Produção e Staff | Fados à Mesa", desc: "Conheça a equipa que faz a noite acontecer: produção executiva e artística, cozinha e sala da 1ª edição do Fados à Mesa." },
        missao: { title: "A Missão — Cultura Portuguesa na Suíça | Fados à Mesa", desc: "Levar a cultura portuguesa à Suíça — uma noite, uma mesa e uma guitarra de cada vez. Cultura, mesa e encontro: os valores do Fados à Mesa." },
        contacto: { title: "Contacto — Fale Connosco | Fados à Mesa", desc: "Contactos do evento Fados à Mesa: reservas de grupos, parcerias e patrocínios, imprensa e questões sobre a 1ª edição." },
        local: { title: "Local — Centro Papa Giovanni, Emmenbrücke | Fados à Mesa", desc: "Como chegar ao Centro Papa Giovanni (Hübelistrasse 55, Emmenbrücke): transportes públicos, carro, Uber e bicicleta. Estacionamento gratuito." },
        noticias: { title: "Notícias — Fado, Cultura Portuguesa e Novidades | Fados à Mesa", desc: "Anúncios oficiais do Fados à Mesa e notícias selecionadas sobre os nossos artistas: Rafael Pacheco, Ginestal Martins, Cátia Garcia, Daniel Pinto Coelho e Madalena Gil." },
        confirmar: { title: "Confirmar Presença — Escolha o Prato | Fados à Mesa", desc: "Confirme a sua presença no Fados à Mesa e escolha o prato principal (peixe ou carne) até 1 de novembro de 2026." },
        bilhetes: { title: "Bilheteira Oficial — Comprar Bilhetes | Fados à Mesa", desc: "Compre o seu bilhete para o Fados à Mesa na bilheteira oficial (Eventim / Ticket Corner). Evento exclusivo, lugares limitados. 14.11.2026, Emmenbrücke." },
        privacidade: { title: "Política de Privacidade | Fados à Mesa", desc: "Política de privacidade do Fados à Mesa — tratamento de dados pessoais em conformidade com a lei suíça (nLPD)." },
        associacao: { title: "A Associação | Fados à Mesa", desc: "A Associação Fados à Mesa: quem somos, dados institucionais, direção, parceiros, quotas, pedido de adesão e estatutos." },
        termos: { title: "Termos e Condições | Fados à Mesa", desc: "Termos e condições do site e do evento Fados à Mesa." },
        recursos: { title: "Centro de Recursos — Imprensa e Parceiros | Fados à Mesa", desc: "Materiais oficiais do Fados à Mesa para imprensa e parceiros: project book, press kit, logótipos e programa da noite." },
        patrocinadores: { title: "Patrocinadores Oficiais | Fados à Mesa", desc: "Os parceiros oficiais do Fados à Mesa — uma noite portuguesa na Suíça." },
    },
    assoc: {
        titulo: "A ASSOCIAÇÃO",
        intro: "Uma associação sem fins lucrativos, politicamente neutra e confessionalmente independente, constituída em Emmen a 25 de setembro de 2026.",
        subnav: { quemSomos: "Quem Somos", dados: "Dados", direcao: "Direção", parceiros: "Parceiros", quotas: "Quotas", adesao: "Adesão", estatutos: "Estatutos" },
        quemSomos: {
            titulo: "QUEM SOMOS",
            p1: "A Associação Fados à Mesa é uma associação sem fins lucrativos, politicamente neutra e confessionalmente independente, com sede em Emmen, no Cantão de Lucerna. Tem por fim promover, preservar e divulgar a cultura portuguesa e lusófona na Suíça, em particular o fado, a música, a gastronomia, a língua e as tradições portuguesas.",
            p2: "Para isso, organizamos eventos culturais, musicais, gastronómicos, educativos e sociais, sendo o nosso projeto principal o evento «Fados à Mesa». Promovemos o intercâmbio cultural entre a comunidade lusófona e a população suíça, apoiamos artistas e criadores de expressão portuguesa e cooperamos com comunas, cantões, fundações, empresas, instituições culturais e outras associações.",
            p3: "As nossas atividades são abertas ao público em geral. A associação não prossegue fins lucrativos: eventuais excedentes são integralmente afetos aos fins estatutários e nunca são distribuídos aos membros.",
        },
        dados: {
            titulo: "DADOS INSTITUCIONAIS",
            denominacao: "Denominação", formaJuridica: "Forma jurídica", sede: "Sede", morada: "Morada",
            constituicao: "Data de constituição", duracao: "Duração", uid: "Número UID", conta: "Conta bancária",
            exercicio: "Exercício social", contacto: "Contacto",
            denominacaoV: "Associação Fados à Mesa (Verein Fados à Mesa)",
            formaJuridicaV: "Associação sem fins lucrativos, art. 60.º e ss. ZGB",
            sedeV: "Comuna de Emmen, Cantão de Lucerna, Suíça",
            moradaV: "Gerliswilstrasse 46, 6020 Emmenbrücke",
            constituicaoV: "25.09.2026 (Assembleia de Fundação, Ata n.º 1)",
            duracaoV: "Tempo indeterminado",
            emTratamento: "Em tratamento", aDesignar: "A designar",
            exercicioV: "Ano civil",
        },
        direcao: {
            titulo: "DIREÇÃO E MEMBROS FUNDADORES",
            comite: "Comité Executivo", mandato: "Mandato 2026–2028",
            fundadores: "Membros fundadores com funções nos dias de evento",
            nota: "A Presidente, a Vice-Presidente, a Diretora de Logística e o Diretor Técnico são os quatro membros fundadores da associação.",
            paulaAngelinoNota: "Assume também a direção artística, o marketing, o design e a comunicação.",
            cristinaNota: "Assume todos os poderes executivos em caso de impedimento da Presidente.",
            paulaSilvaNota: "Gestão da logística e das equipas nos dias de evento.",
            pauloNota: "Coordenação técnica dos eventos.",
            cargoPaulaAngelino: "Presidente e Diretora Executiva",
            cargoCristina: "Vice-Presidente",
            cargoPaulaSilva: "Membro fundador e Diretora de Logística",
            cargoPaulo: "Membro fundador e Diretor Técnico",
        },
        parceiros: {
            titulo: "PARCEIROS E PATROCINADORES",
            intro: "Instituições e parceiros que se juntaram a nós para dar voz à cultura portuguesa na Suíça. A cultura também se constrói em parceria.",
            institucional: "Parceiro Institucional",
            patrocinadores: "Patrocinadores",
            parceiroInstitucional: "Parceiro Institucional",
            celimar: "Parceiro Exclusivo do Ramo da Consultoria e Seguros",
            ptPrint: "Gráfica Parceira",
            barniPost: "Media Partner · Edição de 21 de Outubro de 2026",
            tiers: { exclusiva: "Patrocinadora Exclusiva", oficial: "Parceiro Oficial", premium: "Patrocinador Premium Oficial", intermediario: "Patrocinador Intermediário", apoiante: "Apoiante" },
            tiersPlural: { exclusiva: "Patrocinadora Exclusiva", oficial: "Parceiro Oficial", premium: "Patrocinadores Premium", intermediario: "Patrocinadores Intermediários", apoiante: "Apoiantes" },
        },
        quotas: {
            titulo: "QUOTAS E COMO SER SÓCIO",
            valor: "Quota: CHF 2 por mês (CHF 24 por ano).",
            isencao: "Os membros fundadores e os membros honorários estão isentos de quota, com caráter permanente.",
            comoPagar: "Como pagar a quota. Enquanto a conta bancária da associação está a ser designada, a quota pode ser paga em numerário, diretamente na {famosa}. Guarde o comprovativo de pagamento e anexe-o ao pedido de adesão.",
            admissao: "Admissão. O pedido de adesão é analisado pelo Comité Executivo, que decide nos termos do art. 6.º dos Estatutos.",
            categoriasTitulo: "Categorias de membros (art. 5.º dos Estatutos)",
            fundadores: "Fundadores — isentos de quota, com caráter permanente",
            efetivos: "Efetivos — pessoas singulares ou coletivas admitidas pelo Comité Executivo",
            honorarios: "Honorários — serviços relevantes à associação, isentos de quota",
            apoiantes: "Apoiantes — apoiam financeiramente a associação; não têm direito de voto",
        },
        form: {
            titulo: "PEDIDO DE ADESÃO",
            nome: "Nome completo", rua: "Rua e número", cp: "Código postal", localidade: "Localidade", pais: "País",
            email: "E-mail", telefone: "Telefone", telefoneOpc: "opcional",
            categoria: "Categoria pretendida", catEfetivo: "Membro efetivo", catApoiante: "Membro apoiante",
            comprovativo: "Comprovativo de pagamento da quota",
            comprovativoNota: "PDF, JPG ou PNG · máx. 10 MB",
            escolherFicheiro: "Escolher ficheiro",
            aceiteEstatutos: "Li e aceito os Estatutos da Associação Fados à Mesa.",
            verEstatutos: "ver Estatutos",
            aceiteDados: "Autorizo o tratamento dos meus dados pessoais pela Associação Fados à Mesa, exclusivamente para a gestão da minha adesão, nos termos da Lei Federal de Proteção de Dados (nDSG).",
            verNota: "ver nota de proteção de dados",
            enviar: "Enviar Pedido", aEnviar: "A enviar...",
            sucesso: "Pedido recebido. O seu pedido de adesão será analisado pelo Comité Executivo. Receberá a resposta por e-mail.",
            erroObrigatorio: "Campo obrigatório",
            erroEmail: "E-mail inválido",
            erroFicheiroTipo: "Apenas PDF, JPG ou PNG",
            erroFicheiroGrande: "O ficheiro excede 10 MB",
            erroGeral: "Não foi possível enviar o pedido. Tenta novamente.",
        },
        estatutos: { titulo: "ESTATUTOS", indice: "Índice", descarregar: "Descarregar Estatutos (PDF)" },
        cartao: {
            titulo: "CARTÃO DE MEMBRO",
            categoriaEfetivo: "Membro Efetivo", categoriaApoiante: "Membro Apoiante",
            numero: "Membro N.º", desde: "Membro desde", valido: "Cartão válido",
            guardar: "Guardar Imagem", partilhar: "Partilhar",
            nota: "Apresente este cartão nos eventos da Associação Fados à Mesa. Guarde a imagem no telemóvel ou adicione esta página ao ecrã principal.",
            invalidoTitulo: "Cartão não válido",
            invalidoTexto: "Este cartão de membro não é válido ou foi revogado. Em caso de dúvida, contacte-nos através da página de Contacto.",
            aCarregar: "A verificar o cartão…",
        },
        protecao: {
            titulo: "PROTEÇÃO DE DADOS",
            texto: "A Associação Fados à Mesa trata os dados pessoais dos seus membros e requerentes exclusivamente para a gestão das adesões e das atividades da associação, em conformidade com a Lei Federal de Proteção de Dados (nDSG) e com o art. 27.º dos Estatutos. Os dados não são cedidos a terceiros para fins comerciais. Para aceder, corrigir ou apagar os seus dados, contacte produktion@fadosamesa.ch.",
        },
    },
    faq: {
        titulo: "Perguntas Frequentes",
        items: [
            { q: "As bebidas estão incluídas no bilhete?", a: "O bilhete inclui porto de honra, entradas, sopa, prato principal, sobremesa e um café por pessoa. Bebidas e digestivos são à parte." },
            { q: "Tenho de confirmar o prato principal?", a: "Sim. Confirme a sua presença e a escolha do prato (peixe ou carne) até 1 de novembro de 2026 em fadosamesa.ch/confirmar." },
            { q: "Onde compro os bilhetes?", a: "Na bilheteira oficial em fadosamesa.ch/bilhetes (Eventim Light / Ticket Corner). O evento é exclusivo e os lugares são limitados." },
            { q: "Como chego ao Centro Papa Giovanni?", a: "Hübelistrasse 55, 6020 Emmenbrücke — 10 minutos a pé da estação Emmenbrücke Gersag, com estacionamento gratuito nas redondezas. Todos os detalhes em fadosamesa.ch/local." },
        ],
    },
    experiencia: {
        tabs: { menu: "Menu do Evento", cultura: "Cultura e Tradição", gastro: "Gastronomia e Vinhos", bar: "Bar" },
        bar: {
            nome: "A Famosa — Café & Sabores",
            cargoA: "Funcionamento e serviço a cargo da",
            cargoB: "Pastelaria Famosa de Emmenbrücke",
            horarioTitulo: "Horário de Funcionamento",
            blocos: [
                { horas: "17H00 – 18H30", estado: "Aberto", nota: "Receção e Porto de Honra, até ao serviço das entradas do jantar." },
                { horas: "18H30 – 23H30", estado: "Encerrado", nota: "Durante todo o evento." },
                { horas: "23H30 – 01H00", estado: "Reaberto", nota: "Em contínuo até ao fecho do espaço." },
            ],
            regra: "A regra da exclusividade e do pagamento no momento da compra mantém-se.",
        },
        tituloA: "Uma noite ",
        tituloGold: "portuguesa",
        tituloB: ",",
        tituloC: "servida à mesa.",
        p1: "Fados à Mesa é um jantar-espetáculo que junta o melhor de dois patrimónios: a gastronomia portuguesa e o Fado. Entre cada prato, a guitarra portuguesa e a voz do fadista enchem a sala, como nas casas de fado de Lisboa — mas aqui, na Suíça.",
        p2: "Uma noite inteira pensada ao pormenor: a mesa posta, as velas acesas, o vinho servido e o silêncio sagrado quando o fado começa.",
        menuLabel: "Menu oficial da 1ª edição",
        menuOficial: {
            bebidasTitulo: "As bebidas são à parte.",
            bebidasTexto: "Não estão incluídas no preço do bilhete.",
            entradas: "Entradas",
            sopa: "Sopa",
            sopaValor: "Caldo Verde",
            sopaTrad: "",
            prato: "Prato Principal",
            peixeLabel: "Opção 1 — Peixe",
            peixeValor: "Lombo de Bacalhau Assado no Forno com Batata a Murro",
            peixeTrad: "",
            carneLabel: "Opção 2 — Carne",
            carneValor: "Lombo de Porco com Batata Assada e Arroz",
            carneTrad: "",
            acompanhamento: "Ambos acompanham com salada de alface e tomate.",
            sobremesa: "Sobremesa",
            sobremesaNota: "Uma de duas opções à escolha",
            sobremesaOpcoes: "Pudim Caseiro · Salada de Frutas",
            final: "Final",
            finalValor: "Café",
            notaBilhetes: "Os bilhetes adquiridos na mesma reserva garantem lugar na mesma mesa, sempre que possível.",
            notaSilencio: "Para preservar a magia do Fado ao vivo, pedimos que entre ou saia da sala apenas durante os intervalos.",
            notaEstacionamento: "Estacionamento gratuito nas proximidades do Centro Papa Giovanni (não pertence à sala; sujeito a disponibilidade).",
            notaRececao: "À chegada, siga as indicações da nossa equipa de receção.",
            fecho: "Esperamos recebê-lo para uma noite inesquecível, de cultura portuguesa, gastronomia e a tradição intemporal do Fado.",
        },
        zoomHint: "Toque no menu para ampliar",
        importante: "Importante",
        notaA: "Cada cliente deverá confirmar a sua presença e a escolha do prato principal (peixe ou carne) até ao dia ",
        notaB: "Cada cliente deverá confirmar a sua presença e a escolha do prato principal até ao dia ",
        prazoData: "1 de novembro de 2026",
        confirmar: "Confirmar o Prato Principal",
        culturaTitulo: "A NOITE, MOMENTO A MOMENTO",
        lineupTitulo: "Line Up da Noite",
        lineup: [
            { hora: "17h00", momento: "Chegada de convidados (até às 17h30)" },
            { hora: "17h00", momento: "Bar aberto (até às 18h30)", link: true },
            { hora: "17h30", momento: "Porto de Honra" },
            { hora: "18h30", momento: "Entradas e bebidas servidas à mesa" },
            { hora: "19h00", momento: "Primeiro show de Fado" },
            { hora: "19h30", momento: "Sopa" },
            { hora: "20h30", momento: "Segundo momento de Fado" },
            { hora: "21h00", momento: "Prato principal" },
            { hora: "21h45", momento: "Terceiro momento de Fado" },
            { hora: "22h30", momento: "Sobremesa e café" },
            { hora: "22h30", momento: "A cozinha fecha" },
            { hora: "23h00", momento: "Último fado da noite" },
            { hora: "23h45", momento: "Fecho de sala — só o bar em funcionamento, até às 01h00 (fecho do espaço)", link: true },
            { hora: "01h30", momento: "Fecho do Centro Papa Giovanni" },
        ],
        lineupLink: "Ver funcionamento do bar",
        lineupNota: "Horário orientativo da 1ª edição — sujeito a confirmação.",
        etiquetaTitulo: "Quando se Canta o Fado",
        etiquetaTexto: "«Silêncio, que se vai cantar o fado.» À portuguesa, quando a guitarra começa, a sala silencia-se: ouve-se em respeito, sente-se em silêncio e aplaude-se no fim. É assim em Lisboa — e será assim à nossa mesa.",
        bilheteTitulo: "O Seu Bilhete Inclui",
        incluido: [
            "Porto de honra à chegada",
            "Entradas",
            "Sopa",
            "Prato principal",
            "Sobremesa",
            "1 café por pessoa",
        ],
        bebidas: "Bebidas e digestivos são à parte.",
        exclusivo: "Evento exclusivo — lugares limitados",
        gastroTitulo: "GASTRONOMIA E VINHOS",
        gastroCardTitulo: "Gastronomia Portuguesa",
        gastroP1: "Os nossos pratos nascem de produtos de origem portuguesa, escolhidos com o respeito de quem cozinha para a família: o azeite, o bacalhau, os enchidos e os doces que atravessam fronteiras para chegar à sua mesa como se faz em Portugal.",
        gastroP2: "Quem prepara cada prato será apresentado em breve — a nossa cozinha está a ser escolhida com o mesmo cuidado com que se afina uma guitarra.",
        vinhosCardTitulo: "Vinhos Portugueses",
        vinhosP1: "Uma seleção de vinhos das melhores regiões de Portugal — do Douro ao Alentejo, do Dão aos verdes do Minho — pensada para acompanhar cada momento do jantar e cada fado da noite.",
        vinhosP2: "A carta de vinhos da 1ª edição será revelada em breve.",
    },
    equipa: {
        titulo: "A NOSSA EQUIPA",
        tabs: { producao: "Produção", staff: "Staff" },
        producaoTitulo: "Equipa de Produção",
        staffTitulo: "Staff — Cozinha, Sala e Bar",
        cozinhaTitulo: "Cozinha",
        salaTitulo: "Sala",
        barTitulo: "Bar",
        apoioTitulo: "Equipa de Staff e Cozinha",
        producao: [
            {
                id: "paula-angelino", nome: "Paula Angelino", papel: "Diretora Executiva — Artística e Criativa",
                texto: "Responsável pela visão artística e criativa do Fados à Mesa, lidera a identidade do projeto, a comunicação e a produção. O seu objetivo é promover a cultura portuguesa através de experiências autênticas que unem música, gastronomia e tradição.",
            },
            {
                id: "paula-silva", nome: "Paula Silva", papel: "Diretora Logística e de Staff",
                texto: "Responsável pela organização operacional e coordenação das equipas, assegura que cada detalhe é planeado com rigor e que cada evento decorre com qualidade e hospitalidade portuguesa.",
            },
            {
                id: "paulo-nunes", nome: "Paulo Nunes", papel: "Diretor Técnico e Responsável de Segurança dos Espaços",
                texto: "Responsável pela coordenação técnica e pela segurança dos espaços, garante que cada evento decorre com excelência, profissionalismo e total confiança.",
            },
        ],
        cozinha: [
            {
                id: "fernando-rocha", nome: "Fernando Rocha", papel: "Chefe de Cozinha",
                texto: "Responsável pela criação e execução dos menus, assegura a qualidade, autenticidade e apresentação de cada prato, valorizando os melhores ingredientes e a tradição da gastronomia portuguesa.",
            },
            {
                id: "cristina-moita", nome: "Cristina Moita", papel: "Sub-Chefe de Cozinha",
                texto: "Responsável pelo apoio à gestão da cozinha e coordenação da equipa, garante a organização, o rigor e o bom funcionamento de todas as áreas, contribuindo para que cada detalhe chegue à mesa com excelência.",
            },
        ],
        apoio: ["Cátia Ambrai", "Paulo", "Márcia Pinheiro"],
        sala: {
            id: "sergio-rego", nome: "Sérgio Rêgo", papel: "Chefe de Sala",
            texto: "Vindo diretamente de Lisboa, trabalha diariamente com os artistas que apresentamos, assegurando um serviço de sala atento, discreto e de excelência, para que cada noite seja uma experiência inesquecível.",
        },
        salaApoio: { nome: "Rui Borges", papel: "Apoio de Sala" },
        barMembro: { nome: "Rui Borges", papel: "Pastelaria Famosa de Emmenbrücke" },
    },
    missao: {
        label: "A Missão",
        tituloA: "LEVAR A ",
        tituloGold: "CULTURA PORTUGUESA",
        tituloB: " À SUÍÇA",
        subtitulo: "A noite em que Portugal convida a Suíça a sentar-se à mesa, homenageando uma amizade construída ao longo de gerações entre o povo português e o país que o acolhe.",
        capitulos: [
            {
                titulo: "A Origem",
                paragrafos: [
                    "O Fados à Mesa nasceu da vontade de apresentar o Fado na sua forma mais autêntica, respeitando a tradição de uma expressão artística reconhecida pela UNESCO como Património Cultural Imaterial da Humanidade.",
                    "Mais do que um género musical, o Fado é uma forma de preservar a memória, transmitir emoções e contar a história de um povo. É um património vivo que atravessa gerações e continua a unir pessoas através da poesia, da música e da identidade cultural portuguesa.",
                ],
            },
            {
                titulo: "Mais do Que um Concerto",
                paragrafos: [
                    "Por essa razão, uma noite de Fado não se vive como um concerto convencional. Vive-se num ambiente intimista, onde a proximidade entre artistas e público cria uma experiência profundamente humana. Cada interpretação é escutada com respeito, cada palavra é valorizada e cada silêncio faz parte da música.",
                ],
            },
            {
                titulo: "A Cultura Merece Tempo",
                paragrafos: [
                    "No Fados à Mesa, acreditamos que a cultura merece tempo. Merece atenção. Merece um espaço onde o património possa ser vivido com autenticidade, dignidade e elegância.",
                    "O evento foi cuidadosamente concebido para proporcionar uma experiência cultural de elevada qualidade, onde a tradição portuguesa é apresentada de forma contemporânea, acolhedora e fiel ao reconhecimento internacional que o Fado conquistou.",
                ],
            },
            {
                titulo: "Portugal Que Viaja",
                paragrafos: [
                    "Quando a distância dificulta o regresso a Portugal, é Portugal que viaja até junto de quem dele sente saudades. O Fados à Mesa nasce também desse propósito: recriar, por uma noite, um ambiente onde a memória, a identidade e o sentimento de pertença voltam a ganhar vida através da música, da tradição e da cultura portuguesa.",
                ],
            },
            {
                titulo: "Um Convite à Suíça",
                paragrafos: [
                    "Mas este projeto vai além da comunidade portuguesa. É também um gesto de amizade e de partilha. É Portugal que convida a Suíça a sentar-se à nossa mesa. Um convite para descobrir uma cultura reconhecida em todo o mundo, não apenas pela beleza da sua música, mas também pela autenticidade, hospitalidade e riqueza do seu património.",
                    "Mais do que um jantar-espetáculo, o Fados à Mesa pretende afirmar-se como um espaço de encontro entre culturas, onde portugueses, suíços e visitantes de diferentes origens partilham a mesma mesa, escutam as mesmas histórias e descobrem que a cultura é uma linguagem universal capaz de aproximar pessoas.",
                ],
            },
        ],
        valores: [
            { n: "I", title: "Cultura", text: "Levar o Fado — património imaterial da humanidade — a novos públicos." },
            { n: "II", title: "Mesa", text: "Partilhar a gastronomia e os vinhos que contam a história de Portugal." },
            { n: "III", title: "Encontro", text: "Criar na Suíça um ponto de encontro entre culturas, à volta da mesa." },
        ],
        fechoA: "Num tempo em que tantas experiências se vivem com pressa, o Fado convida-nos a fazer precisamente o contrário: a parar, a escutar e a sentir.",
        fechoB: "Porque há momentos em que o maior sinal de respeito não é o aplauso. É o silêncio.",
        fechoFinal: "Silêncio... que se vai cantar o Fado.",
    },
    contacto: {
        titulo: "FALE CONNOSCO",
        intro: "Para qualquer assunto relacionado com os Fados à Mesa, escreve-nos aqui — respondemos com gosto.",
        nome: "Nome",
        nomePh: "O teu nome",
        email: "Email",
        emailPh: "oteuemail@exemplo.com",
        assunto: "Assunto",
        assuntos: [
            "Reservas de grupos",
            "Parcerias e patrocínios",
            "Imprensa e media",
            "Questões sobre a 1ª edição",
            "Outro assunto",
        ],
        mensagem: "Mensagem",
        mensagemPh: "Escreve a tua mensagem...",
        enviar: "Enviar Mensagem",
        aEnviar: "A enviar...",
        erroGenerico: "Não foi possível enviar a mensagem. Tenta novamente, por favor.",
        sucessoTitulo: "Mensagem enviada.",
        sucessoTexto: "Obrigado, {nome}. Recebemos a tua mensagem e respondemos em breve.",
        fecho: "Uma noite Portuguesa, com toda a certeza.",
    },
    local: {
        label: "Onde decorre o evento",
        titulo: "COMO CHEGAR",
        intro: "Toda a informação prática sobre o local e as formas de chegar a Emmenbrücke — transporte público, carro, Uber/táxi ou bicicleta.",
        morada: "Hübelistrasse 55, 6020 Emmenbrücke, Suíça — 47.0706° N, 8.2849° E",
        moradaCurta: "Hübelistrasse 55, 6020 Emmenbrücke",
        comoChegar: "COMO CHEGAR",
        cards: [
            {
                id: "transportes",
                title: "De Transportes Públicos",
                text: "A estação Emmenbrücke Gersag fica a cerca de 10 minutos a pé e é servida por comboios regionais e pelos autocarros 41, 42, 43 e 44. De Lucerna, a linha 2 da VBL liga ao centro de Emmenbrücke; no regresso, o autocarro noturno N2 liga a Lucerna.",
            },
            {
                id: "carro",
                title: "De Carro",
                text: "A 5 minutos da autoestrada A2 (saída Emmen Nord). Estacionamento gratuito da Häger mesmo em frente, limitado aos lugares sinalizados «Häger» — vê todos os detalhes abaixo.",
            },
            {
                id: "uber",
                title: "De Uber ou Táxi",
                text: "A Uber opera em Lucerna e arredores: uma corrida desde o centro de Lucerna demora cerca de 10 minutos.",
            },
            {
                id: "bicicleta",
                title: "De Bicicleta",
                text: "Emmen fica a poucos minutos de bicicleta desde Lucerna, por ciclovias. Há estacionamento para bicicletas no local.",
            },
        ],
        mapsCta: "Abrir no Google Maps",
        mapsTexto: "Aponta a câmara ao código ou toca aqui — a localização exata e os parques mais próximos ficam a um toque de distância.",
        barTitulo: "Bar no Espaço",
        barTexto: "Aberto das 17H00 às 18H30 e das 23H30 às 01H00. Serviço a cargo da Pastelaria Famosa de Emmenbrücke — pagamento no momento da compra.",
        estacionamentoHager: {
            titulo: "Estacionamento Gratuito — Häger",
            intro: "O estacionamento mais próximo do evento é o parque da Häger, mesmo em frente ao Centro Papa Giovanni — gratuito, mas com utilização limitada à capacidade do espaço.",
            pontos: [
                "Apenas os lugares sinalizados com a indicação «Häger» estão disponibilizados aos clientes do evento.",
                "Esta informação é de caráter meramente informativo: não nos responsabilizamos pela lotação do espaço. Não é necessário pagar parque.",
                "Caso o parque esteja lotado, procure nas imediações — existem vários estacionamentos disponíveis, alguns gratuitos e outros pagos.",
            ],
            mapsCta: "Ver estacionamento no Google Maps",
        },
        fecho: "Chegar é fácil. O difícil vai ser ir embora.",
    },
    noticias: {
        label: "Sala de imprensa",
        titulo: "NOTÍCIAS",
        intro: "Bem-vindo à página oficial de Notícias do Fados à Mesa. Aqui encontra os anúncios oficiais mais recentes do Fados à Mesa, juntamente com notícias cuidadosamente selecionadas sobre os artistas que participam no nosso evento. O nosso objetivo é manter os visitantes informados através de fontes fiáveis e oficiais, destacando os artistas que tornam este projeto possível. Esta página é atualizada regularmente sempre que estiver disponível nova informação oficial.",
        socialTitulo: "A NOSSA ÚLTIMA PUBLICAÇÃO",
        socialTituloMulti: "AS NOSSAS ÚLTIMAS PUBLICAÇÕES",
        socialVer: "Ver Publicação",
        socialSeguir: "Siga-nos",
        socialBio: "O Fados à Mesa chegou ao Instagram — acompanhe os anúncios oficiais, os artistas e os bastidores da noite.",
        verTodas: "Ver todas as notícias",
        ultimasTitulo: "ÚLTIMAS NOTÍCIAS",
        filtros: { todas: "Todos", projeto: "Fados à Mesa" },
        pesquisaPh: "Pesquisar notícias por palavra-chave...",
        lerMais: "Ler Mais",
        carregarMais: "Carregar Mais",
        aCarregar: "A carregar...",
        semResultados: "Nenhuma notícia encontrada. Experimente outro artista ou palavra-chave.",
        fonte: "Fonte",
        ctaTitulo: "Sinta o Fado ao Vivo",
        ctaReservar: "Reserve o Seu Lugar",
    },
    patrocinadoresPage: {
        titulo: "PATROCINADORES OFICIAIS",
        texto: "Os parceiros que tornam esta noite possível — obrigado por acreditarem na cultura portuguesa na Suíça.",
    },
    confirmacao: {
        label: "1ª Edição · 14 de Novembro de 2026",
        titulo: "CONFIRMA A TUA PRESENÇA",
        introA: "Confirma a tua presença e escolhe o prato principal até ao dia ",
        prazoData: "1 de novembro de 2026",
        nome: "Nome completo",
        nomePh: "O teu nome",
        email: "Email",
        emailPh: "oteuemail@exemplo.com",
        bilhete: "Número do bilhete (Ticket Corner)",
        bilhetePh: "Ex.: TC-123456789",
        escolhePrato: "Escolhe o prato principal",
        opcoes: [
            { id: "peixe", title: "Opção 1 — Peixe", desc: "Posta de bacalhau assada com batata a murro e salada" },
            { id: "carne", title: "Opção 2 — Carne", desc: "Lombo de porco assado com batata a murro e salada" },
        ],
        submit: "Confirmar Presença",
        aRegistar: "A registar...",
        erroGenerico: "Não foi possível registar a confirmação. Tenta novamente, por favor.",
        sucessoTitulo: "Presença confirmada.",
        sucessoTexto: "Obrigado, {nome}. A tua escolha ({prato}) ficou registada. Até já — a 14 de novembro, à mesa.",
        peixe: "peixe",
        carne: "carne",
    },
    vantagens: {
        label: "Sócios",
        titulo: "VANTAGENS E PROTOCOLOS DE SÓCIO",
        intro: "Ser sócio do Fados à Mesa custa CHF 2 por mês (CHF 24 por ano) e dá acesso a descontos em vários sítios, em Portugal e na Suíça — a começar já na 1ª edição.",
        prova: "Para usufruir dos protocolos basta apresentar o seu Cartão de Membro Digital (com QR code) ou indicar o seu número de sócio.",
        bilhetesTitulo: "Bilhetes da 1ª Edição — 14 de Novembro de 2026",
        bilhetesIntro: "Desconto imediato na aquisição de bilhetes físicos na Pastelaria Famosa, em Emmenbrücke (dinheiro, Twint ou transferência).",
        colBilhete: "Bilhete",
        colAte: "Até 31.10.2026",
        colDepois: "A partir de 01.11.2026",
        linhas: [
            ["Adulto, preço normal", "CHF 119.90", "CHF 129.90"],
            ["Sócio, 1.º bilhete de adulto (− CHF 20)", "CHF 99.90", "CHF 109.90"],
            ["Adulto em compra conjunta com sócio (− CHF 10)", "CHF 109.90", "CHF 119.90"],
            ["Criança (6–15 anos)", "CHF 65.00", "CHF 65.00"],
            ["Criança em compra conjunta com sócio (− CHF 5)", "CHF 60.00", "CHF 60.00"],
        ],
        bilhetesNota: "Os descontos de sócio aplicam-se apenas a bilhetes comprados em conjunto com o sócio, na mesma transação. O número de sócio deve constar em todos os bilhetes, para registo interno.",
        fisicoTitulo: "Porque só em bilhetes físicos?",
        fisicoTexto: "Por motivos de gestão de projeto, nesta 1ª edição os bilhetes com desconto de sócio só estão disponíveis fisicamente, na Pastelaria Famosa. Pretendemos resolver esta situação numa próxima edição e estender o desconto também à compra online.",
        protocolosTitulo: "Protocolos com Parceiros",
        srVinhoTitulo: "Sr. Vinho — Restaurante Típico",
        srVinhoTag: "Parceiro Oficial",
        srVinhoTexto: "Todos os sócios do Fados à Mesa têm, desde já, 10% de desconto no pagamento a dinheiro sobre o valor final do jantar no restaurante Sr. Vinho, e um digestivo de oferta.",
        srVinhoCta: "Ver o menu do Sr. Vinho",
        famosaTitulo: "Pastelaria Famosa — Emmenbrücke",
        famosaTag: "Patrocinadora Exclusiva",
        famosaTexto: "Ponto de venda oficial dos bilhetes físicos com desconto de sócio para a 1ª edição. Pagamento em dinheiro, Twint ou transferência bancária.",
        cr7Titulo: "CR7 Helder — Transporte em Limousine",
        cr7Tag: "Patrocinador Premium Oficial",
        cr7Texto: "Com o código CR7, os sócios têm 10% de desconto em todas as limousines da Vachoux (Helder Pacheco). Oferta limitada ao território da cidade de Genebra, em percursos de 45 minutos, com limousines para 12 a 16 pessoas no máximo.",
        cr7Codigo: "Código: CR7",
        cr7Cta: "Reservar em vachoux.com",
        emBreve: "Mais protocolos em breve, em Portugal e na Suíça. Os sócios serão informados por e-mail.",
        ctaTitulo: "Ainda não é sócio?",
        ctaTexto: "Adesão simples, online, por CHF 24/ano.",
        cta: "Tornar-me sócio",
    },
    bilhetes: {
        precosTitulo: "Preços dos Bilhetes",
        precosStandard: "Standard",
        precosEarlyBird: "Early Bird",
        precosNormal: "Preço Normal",
        precosCrianca: "Criança (6–15 anos)",
        precosCriancaNota: "Jantar com água e um sumo da casa de oferta · Não inclui Porto de Honra",
        socioLink: "Sócios: desconto de CHF 20 no 1.º bilhete — ver vantagens de sócio",
        precosNota: "Bebidas não incluídas · Lugares limitados · Dress code: jantar elegante (não é gala, mas quase)",
        titulo: "BILHETEIRA",
        data: "14 de Novembro de 2026 · Centro Papa Giovanni, Emmenbrücke",
        exclusivo: "Evento exclusivo · Lugares limitados",
        confirmarReserva: "Confirmar Reserva",
        nota: "Bilheteira oficial Eventim. Após a compra, confirma a tua presença e a escolha do prato em ",
    },
    ticketcorner: { label: "PARCEIRO OFICIAL DE VENDAS" },
    privacidade: {
        label: "Fados à Mesa",
        titulo: "POLÍTICA DE PRIVACIDADE",
        seccoes: [
            {
                title: "1. Responsável pelo tratamento de dados",
                text: "O responsável pelo tratamento de dados pessoais neste site é a Associação Fados à Mesa (adiante «nós»), UID CHE-306.330.271, Gerliswilstrasse 46, 6020 Emmenbrücke, Suíça. Para qualquer questão relacionada com proteção de dados, contacte-nos através da página de Contacto.",
            },
            {
                title: "2. Enquadramento legal",
                text: "O tratamento de dados pessoais é efetuado em conformidade com a Lei Federal Suíça de Proteção de Dados (nLPD/revDSG, em vigor desde 1 de setembro de 2023) e demais legislação suíça aplicável.",
            },
            {
                title: "3. Dados que recolhemos",
                text: "Nesta fase, o site não recolhe dados pessoais através de formulários. Quando nos contacta por email, tratamos o seu endereço e o conteúdo da mensagem apenas para responder ao seu pedido. Dados de reserva ou compra de bilhetes serão tratados futuramente através da plataforma Ticket Corner, nos termos da política de privacidade dessa plataforma.",
            },
            {
                title: "4. Cookies e ferramentas de análise",
                text: "Este site não utiliza cookies de rastreamento nem ferramentas de análise de terceiros nesta fase. Caso venham a ser introduzidos, esta política será atualizada em conformidade.",
            },
            {
                title: "5. Os seus direitos",
                text: "Nos termos da legislação suíça, tem direito a solicitar informação sobre os seus dados pessoais, bem como a respetiva retificação ou eliminação. Para exercer estes direitos, contacte-nos através da página de Contacto.",
            },
            {
                title: "6. Alterações",
                text: "Reservamo-nos o direito de atualizar esta política a qualquer momento. A versão em vigor é a publicada nesta página. Última atualização: setembro de 2026.",
            },
        ],
    },
    termos: {
        label: "Fados à Mesa",
        titulo: "TERMOS E CONDIÇÕES",
        seccoes: [
            {
                title: "1. Objeto",
                text: "Os presentes Termos & Condições regulam a utilização do site Fados à Mesa e a participação no evento. Ao utilizar este site, aceita integralmente estas condições.",
            },
            {
                title: "2. Propriedade intelectual",
                text: "O conceito, a denominação «Fados à Mesa», o logótipo, os textos, as fotografias, os vídeos, o design e todos os conteúdos deste site são propriedade exclusiva da organização do evento e encontram-se protegidos pela Lei Federal Suíça do Direito de Autor e Direitos Conexos (LDA/URG) e pelas convenções internacionais aplicáveis. É expressamente proibida a reprodução, cópia, imitação, distribuição ou utilização, total ou parcial, do conceito, da marca, dos textos, das imagens ou de qualquer elemento distintivo do projeto, sem autorização prévia e por escrito da organização. Qualquer violação será objeto de ação judicial nos termos da legislação suíça.",
            },
            {
                title: "3. Bilhetes e reservas",
                text: "A venda de bilhetes será efetuada através da plataforma Ticket Corner, aplicando-se os termos e condições dessa plataforma. O evento tem lotação limitada; a reserva só é válida após confirmação do pagamento.",
            },
            {
                title: "4. Programa e alterações",
                text: "A organização reserva-se o direito de ajustar o programa, os horários, o menu e o elenco por motivos de força maior, garantindo sempre a qualidade da experiência anunciada.",
            },
            {
                title: "5. Responsabilidade",
                text: "A organização não se responsabiliza por danos decorrentes de informação de terceiros, falhas técnicas alheias ou utilização indevida do site. O consumo de bebidas alcoólicas é reservado a maiores de idade, nos termos da legislação suíça.",
            },
            {
                title: "6. Lei aplicável e foro",
                text: "Estes Termos regem-se pelo direito suíço. Para qualquer litígio é competente o foro do domicílio da organização, na Suíça. Última atualização: setembro de 2026.",
            },
        ],
    },
    artistPage: {
        naoEncontrado: "Artista não encontrado.",
        imprensa: "Imprensa & Destaques",
        emPalco: "Em palco",
        oQueA: "O que te ",
        oQueGold: "espera",
        oQueB: "",
    },
    artists: {
        "rafael-pacheco": {
            role: "Guitarra Portuguesa",
            bio: "Natural de Portimão (2000), começou aos 11 anos na escola de fado Boa Esperança e formou-se com o prestigiado guitarrista de guitarra portuguesa Antunes, o Príncipe.\n\nVencedor do Prémio Novos Talentos Ageas, na Casa da Música (2023), é músico residente em emblemáticas casas de fado, de Viseu a Lisboa.",
        },
        "ginestal-martins": {
            role: "Viola de Fado",
            bio: "Violista de fado do circuito lisboeta, é o alicerce musical de incontáveis noites — a viola que sustenta, com sensibilidade, cada voz.\n\nAcompanha fadistas nas casas de fado e nas Visitas Cantadas da EGEAC, pelos bairros históricos de Lisboa, ao lado de guitarristas como Rafael Pacheco. Também se apresenta como fadista.",
        },
        "catia-garcia": {
            role: "Fadista",
            bio: "Fadista de alma e tradição, leva ao palco a emoção de quem vive o fado por dentro. Em 2021 editou o álbum «À Procura do Fado».\n\nPresença regular na televisão (RTP) e nas noites de fado de Lisboa, incluindo a emblemática casa Sr. Vinho.",
        },
        "daniel-pinto-coelho": {
            role: "Fadista",
            bio: "Natural de Valongo, subiu ao palco pela primeira vez aos 4 anos e estudou na London Music School, antes de se render ao fado em 2014.\n\nFaz parte do elenco da emblemática casa de fado Sr. Vinho, em Lisboa, onde a sua voz elegante é presença habitual.",
        },
        "madalena-gil": {
            role: "Fadista",
            bio: "Natural de Almeirim, encantou o país no The Voice Kids Portugal, em 2021, com o fado «Ser Fadista».\n\nUma voz jovem com alma antiga, que promete levar o fado — e o nome de Portugal — ainda mais longe.",
        },
    },
};
